import random from './random';

const ALL_COLORS = [
  'light-pink',
  'light-green',
  'light-blue',
  'light-red',
  'light-teal',
  'light-orange',
  'light-purple',
  'dark-pink',
  'dark-green',
  'dark-blue',
  'dark-red',
  'dark-teal',
  'dark-brown',
  'dark-orange',
  'dark-purple',
];

const rand = random(0, ALL_COLORS.length - 1);
export function getColor() {
  const i = rand();
  return colorMap(ALL_COLORS[i % ALL_COLORS.length]);
}

export function colorMap(color) {
  switch (color) {
    case 'yellow': {
      return 'rgba(240,208,4, .7)';
    }
    case 'purple': {
      return 'rgba(187,108,220, .7)';
    }
    case 'blue': {
      return 'rgba(0,110,183, .7)';
    }
    case 'red': {
      return 'rgba(232,79,62, .7)';
    }
    case 'green': {
      return 'rgba(87,181,70, .7)';
    }
    case 'orange': {
      return 'rgba(255,148,25, .7)';
    }
    case 'black': {
      return 'rgba(68,68,68, .7)';
    }
    case 'sky': {
      return 'rgba(0,186,220, .7)';
    }
    case 'pink': {
      return 'rgba(255,109,196, .7)';
    }
    case 'lime': {
      return 'rgba(72,229,141, .7)';
    }
    case 'default': {
      return 'rgba(124,181,236, 0.7)';
    }

    case 'asana-hot-pink':
    case 'dark-pink': {
      return 'rgba(234, 78, 157, 0.7)';
    }
    case 'asana-green':
    case 'dark-green': {
      return 'rgba(98, 210, 111, 0.7)';
    }
    case 'asana-blue':
    case 'dark-blue': {
      return 'rgba(0, 0, 139, 0.7)';
    }
    case 'asana-red':
    case 'dark-red': {
      return 'rgba(232, 56, 79, 0.7)';
    }
    case 'asana-aqua':
    case 'dark-teal': {
      return 'rgba(32, 170, 234, 0.7)';
    }
    case 'asana-yellow':
    case 'dark-brown': {
      return 'rgba(238, 195, 0, 0.7)';
    }
    case 'asana-orange':
    case 'dark-orange': {
      return 'rgba(253, 97, 44, 0.7)';
    }
    case 'asana-indigo':
    case 'dark-purple': {
      return 'rgba(122, 111, 240, 0.7)';
    }
    case 'asana-cool-gray':
    case 'dark-warm-gray': {
      return 'rgba(51, 46, 44, 0.7)';
    }
    case 'asana-magenta':
    case 'light-pink': {
      return 'rgba(227, 98, 227, 0.7)';
    }
    case 'asana-yellow-green':
    case 'light-green': {
      return 'rgba(164, 207, 48, 0.7)';
    }
    case 'asana-blue':
    case 'light-blue': {
      return 'rgba(65, 134, 224, 0.7)';
    }
    case 'asana-pink':
    case 'light-red': {
      return 'rgba(252, 145, 173, 0.7)';
    }
    case 'asana-blue-green':
    case 'light-teal': {
      return 'rgba(55, 197, 171, 0.7)';
    }
    case 'asana-pink':
    case 'light-yellow': {
      return 'rgba(255, 255, 204, 0.7)';
    }
    case 'asana-yellow-orange':
    case 'light-orange': {
      return 'rgba(253, 154, 0, 0.7)';
    }
    case 'asana-purple':
    case 'light-purple': {
      return 'rgba(170, 98, 227, 0.7)';
    }
    case 'asana-cool-gray':
    case 'light-warm-gray': {
      return 'rgba(141, 163, 166, 0.7)';
    }
    case 'asana-none':
    case 'none': {
      return 'rgba(179, 190, 196, 0.7)';
    }
    default: {
      if (color && color.indexOf('custom-') > -1) {
        return color.replace('custom-', '');
      }
      if (color) {
        return color;
      }
      return 'rgba(179, 190, 196, 0.7)';
    }
  }
}

export default colorMap;
